
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M4.25 2.25A1.75 1.75 0 002.5 4v8c0 .966.784 1.75 1.75 1.75h5.5A1.75 1.75 0 0011.5 12V4a1.75 1.75 0 00-1.75-1.75h-5.5zM4 4a.25.25 0 01.25-.25h5.5A.25.25 0 0110 4v8a.25.25 0 01-.25.25h-5.5A.25.25 0 014 12V4zm10.25 6.25A1.75 1.75 0 0012.5 12v8c0 .966.784 1.75 1.75 1.75h5.5A1.75 1.75 0 0021.5 20v-8a1.75 1.75 0 00-1.75-1.75h-5.5zM14 12a.25.25 0 01.25-.25h5.5A.25.25 0 0120 12v8a.25.25 0 01-.25.25h-5.5A.25.25 0 0114 20v-8zm-1.5-8c0-.966.784-1.75 1.75-1.75h5.5c.966 0 1.75.784 1.75 1.75v3a1.75 1.75 0 01-1.75 1.75h-5.5A1.75 1.75 0 0112.5 7V4zm1.75-.25A.25.25 0 0014 4v3c0 .138.112.25.25.25h5.5A.25.25 0 0020 7V4a.25.25 0 00-.25-.25h-5.5zm-10 11.5A1.75 1.75 0 002.5 17v3c0 .966.784 1.75 1.75 1.75h5.5A1.75 1.75 0 0011.5 20v-3a1.75 1.75 0 00-1.75-1.75h-5.5zM4 17a.25.25 0 01.25-.25h5.5A.25.25 0 0110 17v3a.25.25 0 01-.25.25h-5.5A.25.25 0 014 20v-3z"}})])
          )
        }
      }
    